var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDealTag = function SvgDealTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.87 50",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.69 0H19.97l-7.65 9.77h87.37zM9.75 13 0 25.52l19.06 24.41 80.81.07V13.09Zm32.84 22.91a6.8 6.8 0 0 1-2.35 2.47 7.1 7.1 0 0 1-2.33.89 15.5 15.5 0 0 1-3 .26h-5.13V25h5.27a13.8 13.8 0 0 1 3.07.3 6.8 6.8 0 0 1 2.16.84 6.5 6.5 0 0 1 2.37 2.48 7.37 7.37 0 0 1 .87 3.66 7.1 7.1 0 0 1-.93 3.63M56 27.8h-6.78v2.51h6.3v2.82h-6.3v3.59H56v2.81H45.49V25H56Zm12.92 11.73-1-2.94h-5.4l-1 2.94h-3.79L63.1 25h4.32l5.37 14.54Zm16.36 0H74.79V25h3.75v11.72h6.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.46 28.19a4.3 4.3 0 0 0-1.18-.39 13 13 0 0 0-1.81-.1h-.94v9.1h.94a11.6 11.6 0 0 0 2-.12 4.5 4.5 0 0 0 1.22-.44 3.65 3.65 0 0 0 1.5-1.57 6.2 6.2 0 0 0 0-4.88 3.63 3.63 0 0 0-1.73-1.6M63.42 33.93H67l-1.79-5.21z"
  }))));
};
export default SvgDealTag;